/**
 * Map theme bridge — allows non-React modules (catchmentRenderer, useMapInteractions)
 * to access the current theme's map colors without a React context dependency.
 *
 * ThemeProvider calls setMapColors() whenever the theme changes.
 * Utility modules call getMapColors() to read the current palette.
 */
import palettesData from './palettes.json'

export interface MapColors {
  walk: string[]
  drive: string[]
  motor: string[]
  ringBuffer: string
  selection: string
  highlight: string
}

// Default to the dark palette so there's always a valid value
let currentMapColors: MapColors = (palettesData as any)['geonexora-dark'].map

export function setMapColors(colors: MapColors) {
  currentMapColors = colors
}

export function getMapColors(): MapColors {
  return currentMapColors
}
